module.exports = __webpack_public_path__ + "static/media/fontawesome.c2c3993e.ico";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/fontawesome.ico
// module id = 98
// module chunks = 0